<template>
  <div
    class="
      sticky
      top-0
      z-10
      flex-shrink-0 flex
      h-16
      bg-white
      border-b border-gray-200
      lg:hidden
    "
  >
    <button
      type="button"
      class="
        px-4
        border-r border-gray-200
        text-gray-500
        focus:outline-none focus:ring-2 focus:ring-inset focus:ring-purple-500
        lg:hidden
      "
      @click="$emit('sideBarToggled')"
    >
      <span class="sr-only">Open sidebar</span>
      <MenuAlt1Icon class="h-6 w-6" aria-hidden="true" />
    </button>
    <div class="flex-1 flex justify-between px-4 sm:px-6 lg:px-8">
      <div class="flex-1 flex">
        <form class="w-full flex md:ml-0" action="#" method="GET">
          <label for="search-field" class="sr-only">Search</label>
          <div class="relative w-full text-gray-400 focus-within:text-gray-600">
            <div
              class="
                absolute
                inset-y-0
                left-0
                flex
                items-center
                pointer-events-none
              "
            >
              <SearchIcon class="h-5 w-5" aria-hidden="true" />
            </div>
            <input
              id="search-field"
              name="search-field"
              class="
                block
                w-full
                h-full
                pl-8
                pr-3
                py-2
                border-transparent
                text-gray-900
                placeholder-gray-500
                focus:outline-none
                focus:ring-0
                focus:border-transparent
                focus:placeholder-gray-400
                sm:text-sm
              "
              placeholder="Search"
              type="search"
            />
          </div>
        </form>
      </div>
      <div class="flex items-center">
        <!-- Profile dropdown -->
        <Menu as="div" class="ml-3 relative">
          <div>
            <MenuButton
              class="
                max-w-xs
                bg-white
                flex
                items-center
                text-sm
                rounded-full
                focus:outline-none
                focus:ring-2
                focus:ring-offset-2
                focus:ring-purple-500
              "
            >
              <span class="sr-only">Open user menu</span>
              <ui-avatar
                backgroundStyling="bg-light-blue-400"
                textStyling="text-white"
              />
              <!-- <img
                class="h-8 w-8 rounded-full"
                src="https://images.unsplash.com/photo-1502685104226-ee32379fefbe?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                alt=""
              /> -->
            </MenuButton>
          </div>
          <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
          >
            <MenuItems
              class="
                origin-top-right
                absolute
                right-0
                mt-2
                w-48
                rounded-md
                shadow-lg
                bg-white
                ring-1 ring-black ring-opacity-5
                divide-y divide-gray-200
                focus:outline-none
              "
            >
              <div
                v-for="(menuSection, menuSectionindex) in profileMenu"
                :key="menuSectionindex"
                class="py-1"
              >
                <MenuItem
                  v-for="(menuItem, menuItemIndex) in menuSection"
                  :key="menuItemIndex"
                  v-slot="{ active }"
                >
                  <Link
                    :href="route(menuItem.route)"
                    :class="[
                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                      'block px-4 py-2 text-sm',
                    ]"
                    >{{ menuItem.text }}</Link
                  >
                </MenuItem>
              </div>
            </MenuItems>
          </transition>
        </Menu>
      </div>
    </div>
  </div>
</template>

<script>
import { MenuAlt1Icon, SearchIcon } from "@heroicons/vue/outline";
import { Menu, MenuItems, MenuItem, MenuButton } from "@headlessui/vue";
export default {
  emits: ["sideBarToggled"],

  components: {
    MenuAlt1Icon,
    SearchIcon,
    Menu,
    MenuItems,
    MenuItem,
    MenuButton,
  },
  props: {
    profileMenu: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      profileToggle: false,
    };
  },
};
</script>